import { render } from "./Reddit.vue?vue&type=template&id=e6144902"
import script from "./Reddit.vue?vue&type=script&lang=js"
export * from "./Reddit.vue?vue&type=script&lang=js"
script.render = render

export default script